import {NgModule} from '@angular/core';
import {DatePipe, JsonPipe} from "@angular/common";
import {GameInstanceStatusPipe} from "./game-instance-status.pipe";
import {GameTypePipe} from "./game-type.pipe";
import {SubscriptionStatusPipe} from "./subscription-status.pipe";
import {FormatCurrencyPipe} from "./format-currency.pipe";
import {DrawDayOfWeekPipe} from "./draw-day-of-week.pipe";
import {MinutesFromMidnightPipe} from "./minutes-from-midnight.pipe";
import {DrawIntervalPipe} from "./draw-interval.pipe";
import {DisplayInvalidEmailReasonPipe} from "./display-invalid-email-reason.pipe";
import {EventSourceToDisplayPipe} from "./event-source-to-display.pipe";
import {PrettyPrintPipe} from "./pretty-print.pipe";

import {AuditEventTypesPipe} from "./audit-event-types.pipe";
import {ErrorTypePipe} from "./error-type.pipe";
import {PhoneFormatPipe} from "./phone-format.pipe";
import {GameStatePipe} from "./game-state.pipe";
import {WinnerPayoutStatusPipe} from "./winner-payout-status.pipe";
import {StripeDisabledReasonPipe} from "./stripe-disabled-reason.pipe";
import {StripeRequirementPipe} from "./stripe-requirement.pipe";
import {ConnectionDurationPipe} from "./connection-duration.pipe";
import {BroadcastNotificationPipe} from "./broadcast-notification.pipe";
import {BroadcastNotificationScopePipe} from "./broadcast-notification-scope.pipe";
import {FaqScopeTypePipe} from "./faq-scope-type.pipe";

@NgModule({
  declarations: [
    GameInstanceStatusPipe,
    GameTypePipe,
    PhoneFormatPipe,
    WinnerPayoutStatusPipe,
    SubscriptionStatusPipe,
    GameStatePipe,
    AuditEventTypesPipe,
    ErrorTypePipe,
    FormatCurrencyPipe,
    DrawDayOfWeekPipe,
    EventSourceToDisplayPipe,
    PrettyPrintPipe,
    DrawIntervalPipe,
    DisplayInvalidEmailReasonPipe,
    MinutesFromMidnightPipe,
    StripeDisabledReasonPipe,
    StripeRequirementPipe,
    ConnectionDurationPipe,
    BroadcastNotificationPipe,
    BroadcastNotificationScopePipe,
    FaqScopeTypePipe
  ],
  exports: [
    GameInstanceStatusPipe,
    DrawIntervalPipe,
    PrettyPrintPipe,
    GameTypePipe,
    DrawDayOfWeekPipe,
    AuditEventTypesPipe,
    ErrorTypePipe,
    PhoneFormatPipe,
    SubscriptionStatusPipe,
    FormatCurrencyPipe,
    WinnerPayoutStatusPipe,
    MinutesFromMidnightPipe,
    GameStatePipe,
    DisplayInvalidEmailReasonPipe,
    EventSourceToDisplayPipe,
    StripeDisabledReasonPipe,
    StripeRequirementPipe,
    ConnectionDurationPipe,
    BroadcastNotificationPipe,
    BroadcastNotificationScopePipe,
    FaqScopeTypePipe
  ],
  providers: [
    DatePipe,
    JsonPipe,
    MinutesFromMidnightPipe,
    GameInstanceStatusPipe,
    DrawIntervalPipe,
    AuditEventTypesPipe,
    ErrorTypePipe,
    DrawDayOfWeekPipe,
    GameTypePipe,
    PhoneFormatPipe,
    GameStatePipe,
    WinnerPayoutStatusPipe,
    EventSourceToDisplayPipe,
    PrettyPrintPipe,
    SubscriptionStatusPipe,
    FormatCurrencyPipe,
    DisplayInvalidEmailReasonPipe,
    StripeDisabledReasonPipe,
    StripeRequirementPipe,
    ConnectionDurationPipe,
    BroadcastNotificationPipe,
    BroadcastNotificationScopePipe,
    FaqScopeTypePipe
  ]
})
export class PipesModule {
}
